export const verifyAvailableLicenseState = {
	availableLicense: null,
	loading: false,
	error: null,
	errorShow: false,
	getData: false,
};
